<template>
  <!-- 售后退款页面 -->
  <div class="content">
    <div class="header">
      <van-nav-bar
        title="退款/售后"
        left-arrow
        @click-left="$router.push('/personalCenter')"
      />
    </div>
    <div class="center">
      <!-- <van-pull-refresh v-model="isLoading" @refresh="onRefresh"> -->
      <van-tabs
        @change="handleClick"
        v-model="activeName"
        title-active-color="#FC563A"
      >
        <!-- 申请售后 -->
        <van-tab name="applys" title="申请售后">
          <van-list
            v-model="loading"
            :finished="finished"
            :immediate-check="false"
            @load="onLoad"
            offset="100"
          >
            <ul v-if="sales.length !== 0">
              <li v-for="(item, index) in sales" :key="index">
                <div class="orderHeader">
                  <span class="orderTitle">订单号:{{ item.record_code }}</span>
                </div>
                <div
                  class="productInfo"
                  v-for="(order, index) in item.detailList"
                  :key="index"
                >
                  <van-checkbox label-disabled @click="getShop(order)">
                    <van-card
                      :title="order.goods_detail_name"
                      :thumb="order.color_img"
                    >
                      <div slot="tags">
                        <van-tag>
                          <span style="margin-right:3.9rem">{{ order.color_name }}</span
                          ><span>X{{ order.num }}</span>
                        </van-tag>
                        <van-tag class="color">7天无理由退货</van-tag>
                      </div>
                    </van-card>
                  </van-checkbox>
                  <div class="qxBtn qsBtn">
                    <div class="btnText">
                      <p v-if="item.is_return_flag == 0">
                        该商品已超过售后期限
                      </p>
                      <p
                        @click="getAfterList(item)"
                        v-else-if="order.saleingNum == order.num"
                      >
                        该商品已申请售后
                      </p>
                      <p
                        @click="getAfterList(item)"
                        v-else-if="order.saleingNum == 0 ? false : true"
                      >
                        <!-- {{ order.saleingNum }}个商品已申请售后<img
                          src="../../assets/img/icon/组 9762@2x.png"
                          alt=""
                        /> -->
                        <span>该商品已申请售后</span>
                      </p>
                    </div>
                    <van-button
                      class="afterSales"
                      round
                      @click="getSale(order)"
                      disabled
                      size="small"
                      v-if="order.status == 1"
                      >申请售后</van-button
                    >
                    <van-button
                      class="afterSales"
                      v-else-if="
                        order.refundNum == order.num || item.is_return_flag == 0
                      "
                      round
                      disabled
                      size="small"
                      @click="getSale(order)"
                      >申请售后</van-button
                    >
                    <van-button
                      class="afterSales"
                      v-else-if="
                        order.refundNum !== order.num &&
                          item.is_return_flag !== 0
                      "
                      round
                      size="small"
                      @click="getSale(order)"
                      >申请售后</van-button
                    >
                  </div>
                </div>
              </li>
            </ul>
            <div class="noImg" v-else>
              <img src="../../assets/img/组 7417@2x.png" alt="" />
            </div>
          </van-list>
        </van-tab>
        <!-- 处 理 中 -->
        <van-tab name="processed" title="处理中"
          ><ul v-if="productInfo.length !== 0">
            <li
              v-for="item in productInfo"
              :key="item.productInfo.service_id"
              @click="toRefundInfoOne(item)"
            >
              <div class="orderHeader">
                <span class="orderTitle">服务单号:{{ item.service_code }}</span>
                <span class="refund">{{ item.listTurnover2.title }}</span>
              </div>
              <div class="productInfo">
                <van-checkbox label-disabled>
                  <van-card
                    :title="item.productInfo.goods_detail_name"
                    :thumb="item.productInfo.color_img"
                  >
                    <div slot="tags">
                      <van-tag>
                        <span style="margin-right:3.84rem">{{ item.productInfo.color_name }}</span>
                        <!-- <span>X{{ item.num }}</span> -->
                      </van-tag>
                      <van-tag class="color">7天无理由退货</van-tag>
                    </div>
                  </van-card>
                </van-checkbox>
              </div>
              <div class="physical" @click.stop="getPlan(item.service_code)">
                <p>{{ item.listTurnover2.service_desc }}</p>
                <p>{{ item.listTurnover2.add_time }}</p>
              </div>
              <div class="qxBtn chuBtn">
                <van-button
                  v-if="item.status == 1"
                  style="margin-left: 0.266667rem;"
                  round
                  color="#F74B2E"
                  size="small"
                  plain
                  @click.stop="onClick(item.service_id)"
                  >撤销申请</van-button
                >
                <van-button
                  size="small"
                  round
                  @click.stop="toRefundInfoOne(item)"
                  >{{ item.service_mode }}详细</van-button
                >
              </div>
            </li>
          </ul>
          <div class="noImg" v-else>
            <img src="../../assets/img/组 7417@2x.png" alt="" />
          </div>
        </van-tab>
        <!-- 服务记录 -->
        <van-tab name="records" title="服务记录"
          ><ul v-if="completeProductInfo.length !== 0">
            <li
              v-for="item in completeProductInfo"
              :key="item.service_id"
              @click="toRefundInfo(item)"
            >
              <div class="orderHeader">
                <span class="orderTitle">服务单号:{{ item.service_code }}</span>
                <span class="refund">{{ item.listTurnover2.title }}</span>
              </div>
              <div class="productInfo">
                <van-checkbox label-disabled>
                  <van-card
                    :title="item.productInfo.goods_detail_name"
                    :thumb="item.productInfo.color_img"
                  >
                    <div slot="tags">
                      <van-tag>
                        <span style="margin-right:3.84rem">{{item.productInfo.color_name}}</span
                        >
                        <span v-if="item.num">X{{ item.num }}</span>
                      </van-tag>
                      <van-tag class="color">7天无理由退货</van-tag>
                    </div>
                  </van-card>
                </van-checkbox>
              </div>
            </li>
          </ul>
          <div class="noImg" v-else>
            <img src="../../assets/img/组 7417@2x.png" alt="" />
          </div>
        </van-tab>
      </van-tabs>
      <!-- </van-pull-refresh> -->
    </div>
  </div>
</template>
<script>
import { Dialog } from "vant";
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      update: true,
      isLoading: false,
      loading: true,
      finished: false,
      productInfo: [],
      pageSize: 10, //每页的条数
      pageNo: 1, //分页
      totalNum: 0, //数据总条数
      sales: [],
      completeProductInfo: [],
      activeName: "applys",
    };
  },
  created() {
    this.getProcessed();
    this.getRefund();
    this.updateType();
    this.gteService();
  },
  methods: {
    updateType() {
      let type = location.search;
      //通过拿到的值不同，更改activeName的值
      if (type === "") {
        this.activeName = " applys ";
      } else if (type === "?type=2") {
        this.activeName = "processed";
      } else if (type === "?type=3") {
        this.activeName = "records";
      }
    },
    handleClick(tab) {
      let queryType;
      if (tab == "applys") {
        queryType = 1;
      } else if (tab == "processed") {
        queryType = 2;
      } else if (tab == "records") {
        queryType = 3;
      }
      this.$router.replace({
        path: "/refund",
        query: {
          type: queryType || 1,
        },
      });
    },
    // 撤销售后申请
    onClick(service_id) {
      Dialog.confirm({
        title: "撤销申请",
        messageAlign: "left",
        message:
          "您将撤销本次申请，如您修改退货方式或退货商品，撤销申请后可重新发起申请，确认继续吗？",
      })
        .then(() => {
          this.$post({
            url: "/saleService/cancellation",
            method: "post",
            params: {
              service_id,
            },
          })
            .then((res) => {
              if (res.retCode == 200) {
                this.$toast("已撤销");
                this.sales = [];
                this.getRefund();
                this.getProcessed();
              } else {
                this.$toast(res.message);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {
          return false;
        });
    },
    // 获取申请售后的订单
    async getRefund() {
      await this.$post({
        url: "/oor/findOmsOrderRecordInfo",
        method: "post",
        params: {
          userId: sessionStorage.getItem("EXCLUSIVE"),
          status: "5,8,9",
          pageNo: this.pageNo,
          pageSize: this.pageSize,
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            this.totalNum = res.data.count;
            this.sales.push(...res.data.code);
            //每一次加载完设置false，便于下次继续加载
            this.loading = false;
            //判断是否还有数据加载
            if (this.sales.length >= this.totalNum) {
              this.finished = true; //结束加载状态
            } else {
              // ++this.pageNo;
            }
          }
        })
        .catch((err) => {
          this.finished = true;
        });
    },
    onLoad() {
      ++this.pageNo;
      this.getRefund();
    },
    // 申请售后跳转到商品详细
    getShop(order) {
      sessionStorage.setItem("P_ID", order.goods_id);
      this.$router.push("/toShopping");
    },
    // 获取处理中的订单
    async getProcessed() {
      await this.$post({
        url: "saleService/list",
        methods: "get",
        params: {
          userId: sessionStorage.getItem("EXCLUSIVE"),
          status: "1,2,3,4,5,6,11",
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            this.productInfo = res.data;
          }
        })
        .catch((err) => {});
    },
    // 获取服务记录订单
    gteService() {
      this.$post({
        url: "/saleService/list",
        method: "get",
        params: {
          userId: sessionStorage.getItem("EXCLUSIVE"),
          status: "7,9,10,12,",
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            this.completeProductInfo = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 跳转到申请售后详情
    getSale(order) {
      sessionStorage.setItem("Record_DetailId", order.record_detail_id);
      this.$router.push({
        path: "/AfterSale",
        params: {},
      });
    },
    // 跳转到处理中详细
    toRefundInfoOne(item) {
      sessionStorage.setItem("orderCode", item.record_code);
      // if (item.service_mode !== "退款") {
      //   this.$router.push({
      //     path: "/returnDetails",
      //     query: {
      //       service_code: item.service_id,
      //       orderCode: item.record_code,
      //     },
      //   });
      // } else {
      this.$router.push({
        path: "/returnAudit",
        query: {
          service_code: item.service_id,
          orderCode: item.record_code,
        },
      });
      // }
    },
    // 跳转到进度详情
    getPlan(item) {
      this.$router.push({
        path: "/AfteProcessStatus",
        query: {
          service_code: item,
        },
      });
    },
    // 服务记录详情
    toRefundInfo(item) {
      sessionStorage.setItem("orderCode", item.record_code);
      if (
        item.service_mode == "退货" ||
        item.status == 9 ||
        item.service_mode == "换货" ||
        item.service_mode == "退款"
      ) {
        this.$router.push({
          path: "/returnDetails",
          query: {
            service_code: item.service_id,
            record_code: item.record_code,
          },
        });
      } else {
        this.$router.push({
          path: "/returnAudit",
          query: {
            service_code: item.service_id,
            record_code: item.record_code,
          },
        });
      }
    },
    // 商品售后详情
    getAfterList(item) {
      this.$router.push({
        path: "/AfterList",
        query: {
          record_code: item.record_code,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  min-height: 100%;
  position: relative;
  background: #e8e8e8;
  .header {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    background-color: #fff;
    .van-nav-bar {
      background-color: #40000000;
      /deep/.van-nav-bar__text {
        color: #000000;
        font-size: 0.45rem;
      }
      /deep/.van-nav-bar__left {
        .van-icon {
          color: #030303;
          font-size: 0.533333rem;
        }
      }
      /deep/.van-nav-bar__title.van-ellipsis {
        font-weight: 600 !important;
      }
    }
  }
  .center {
    margin: 0 0.27rem;
    background-color: #1f000000;
    padding-top: 1.3rem;
    .noImg {
      img {
        width: 6.5rem;
        height: 5.5rem;
        margin: 3rem auto;
        display: block;
      }
    }
    /deep/.van-tabs__line {
      width: 0;
      height: 0;
    }
    ul {
      height: 100%;
      width: 100%;
      margin-bottom: 0.2rem;
      li {
        margin-top: 0.27rem;
        background: rgba(255, 255, 255, 1);
        border-radius: 0.21rem;
        overflow: hidden;
        .orderHeader {
          height: 1.12rem;
          line-height: 1.12rem;
          border-bottom: 1px solid #eeeeee;
          .orderTitle {
            float: left;
            font-size: 0.37rem;
            margin-left: 0.27rem;
            i {
              font-size: 0.37rem;
              vertical-align: middle;
            }
          }
          .refund {
            // width: 4.2rem;
            text-align: right;
            color: #f74b2e;
            float: right;
            font-size: 0.32rem;
            margin-right: 0.3rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          span {
            font-size: 0.45rem;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
          }
        }
        .productInfo {
          .van-checkbox {
            padding: 0.2667rem 0;
            width: 100%;
            background-color: #ffffff;
            border-radius: 0.21rem;
            /deep/.van-checkbox__icon.van-checkbox__icon--round {
              display: none;
            }
          }
          .van-card {
            height: 3rem;
            background-color: #ffffff;
            border-radius: 8%;
            .colors {
              display: block;
              color: #000 !important;
              font-size: 0.32rem;
            }
            .color {
              display: block;
              color: #f74b2e !important;
              font-size: 0.32rem;
            }
            .van-card__content {
              margin-top: 0.5rem;
              margin-left: 0.2rem;
              .van-card__title.van-multi-ellipsis--l2 {
                font-size: 0.37rem;
              }
              .van-tag.van-tag--plain.van-tag--default.van-hairline--surround {
                .van-tag.van-tag--plain.van-tag--danger.van-hairline--surround {
                  font-size: 0.32rem;
                  color: #ccc;
                }
              }
            }
            .van-tag {
              padding: 0.2em 0.3em;
            }
            .van-tag--default {
              padding: 0;
              margin: 0;
              background-color: #fff;
            }
            .van-tag.van-tag--default {
              color: #ccc;
              /deep/p {
                width: 5.2rem;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
            }
            .van-card__price {
              color: red;
            }
            /deep/.van-tag {
              margin: 0.213333rem 0;
            }
          }
          .refundInfo {
            float: right;
            margin-right: 0.4rem;
            margin-bottom: 0.4rem;
            font-size: 0.32rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
          }
        }
        .physical {
          margin-left: 0.133333rem;
          margin-bottom: 0.266667rem;
          width: 8.666667rem;
          // max-height: 1.28rem;
          background-color: #f0f0f0;
          padding: 0.16rem 0.266667rem;
          color: #666666;
          font-size: 0.346667rem;
          line-height: 0.533333rem;
          font-weight: 400;
          font-family: PingFang SC;
          overflow: hidden;
          text-overflow: ellipsis;
          // white-space: nowrap;
          
        }
        .czBtn {
          margin: 0.17rem 0.27rem;
          .van-button {
            float: right;
            margin-right: 0.1rem;
          }
          span {
            font-size: 0.36rem;
            padding: 0 0.2rem;
            display: block;
            float: right;
            display: -webkit-box;
            /* autoprefixer: off */
            -webkit-box-orient: vertical;
            /* autoprefixer: on */
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }
        .qxBtn {
          overflow: hidden;
          padding: 0 0.4rem 0.266667rem 0;
          .afterSales {
            float: right;
            border-color: #999999 !important;
            color: #333333 !important;
          }
          /deep/.van-button--normal {
            padding: 0.133333rem 0.32rem;
            font-size: 0.32rem;
            // height: 0.72rem;
          }
          /deep/.van-button--default {
            border: 0.026667rem solid #999999;
          }
        }
        .qsBtn{
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .chuBtn {
          display: flex;
          flex-direction: row-reverse;
        }
        .btnText {
          margin-left: 0.4rem;
          font-size: 0.32rem;
          font-family: PingFang SC;
          font-weight: 400;
          color: #666666;
          p {
            display: flex;
            align-items: center;
          }
          img {
            width: 0.373333rem;
            height: 0.373333rem;
          }
        }
      }
    }
    .van-tabs {
      margin-top: 0.21rem;
    }
    .van-tabs__content {
      height: 100vh;
    }
  }
}
</style>
